/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from '@linc-technologies/linced-common/models/person';
import type Rubric from '@linc-technologies/linced-common/models/reports/rubric';
import type RubricCriteria from '@linc-technologies/linced-common/models/reports/rubric-criteria';
import type RubricElement from '@linc-technologies/linced-common/models/reports/rubric-element';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: reports.RubricState.
export default class RubricState extends Model {
  declare [Type]: 'reports/rubric-state';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @belongsTo('reports/rubric', { async: true, inverse: null })
  declare rubricId: AsyncBelongsTo<Rubric>;

  @alias('rubricId')
  declare rubric: AsyncBelongsTo<Rubric>;

  @belongsTo('reports/rubric-element', { async: true, inverse: null })
  declare elementId: AsyncBelongsTo<RubricElement>;

  @alias('elementId')
  declare element: AsyncBelongsTo<RubricElement>;

  @belongsTo('reports/rubric-criteria', { async: true, inverse: null })
  declare criterionId: AsyncBelongsTo<RubricCriteria>;

  @alias('criterionId')
  declare criterion: AsyncBelongsTo<RubricCriteria>;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('boolean', { defaultValue: false })
  declare achieved: boolean;

  @attr('number', { defaultValue: 0 })
  declare value: number;
}
